module.exports = "img/button-text-block-quote-on.29ea1c9.svg";